import React from 'react';
import styled from 'styled-components';
import { InstagramIcon, FacebookIcon, WhatsappIcon, GlobeIcon } from './icons/SocialIcons';

const SocialSection = styled.section`
  padding: 60px 0;
  background-color: #121E42;
  color: white;
`;

const SocialTitle = styled.h2`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 2rem;
  color: white;
  
  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

const SocialIconsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 20px;
  
  @media (max-width: 576px) {
    gap: 20px;
  }
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  color: #00E5FF;
  font-size: 1.5rem;
  transition: all 0.3s ease;
  border: 2px solid #00E5FF;
  
  &:hover {
    transform: translateY(-5px);
    background-color: #00E5FF;
    color: #121E42;
    box-shadow: 0 5px 15px rgba(0, 229, 255, 0.3);
  }
  
  @media (max-width: 576px) {
    width: 50px;
    height: 50px;
    font-size: 1.3rem;
  }
`;

const SocialNetworks: React.FC = () => {
  return (
    <SocialSection id="redes-sociais">
      <div className="container">
        <SocialTitle>Acompanhe o Grupo Nobre</SocialTitle>
        <SocialIconsContainer>
          <SocialLink 
            href="https://www.instagram.com/nobreeducacao" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <InstagramIcon size={28} />
          </SocialLink>
          <SocialLink 
            href="https://www.facebook.com/nobreeducacao" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FacebookIcon size={28} />
          </SocialLink>
          <SocialLink 
            href="https://wa.me/5511972736170" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <WhatsappIcon size={28} />
          </SocialLink>
          <SocialLink 
            href="https://www.nobreeducacao.com.br" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Site Oficial"
          >
            <GlobeIcon size={28} />
          </SocialLink>
        </SocialIconsContainer>
      </div>
    </SocialSection>
  );
};

export default SocialNetworks;
